'use strict';
import $ from 'jquery';
import '../vendor/magnific-popup.js';

/**
 * Open modal
 * @param {object} $link jquery object of element that needs to open the modal. NOTE: it needs data-modal-target attribute also. That is class or id to element it has in modal.
 * @param {object.onClose} onClose function
 * @param {object.compact} compact variable to show compact style of modal
 * @param {object.centerVertical} centerVertical variable to align modal vertically center
 * @param {object.hideCloseLabel} hideCloseLabel hide the close label (text)
 * @param {object.disableBodyScroll} disableBodyScroll disable body scroll while modal is open (FIX: doesn't enable content scroll, content might be hidden)
 */

export const openModal = ($link, {
	onClose = () => {},
	compact = false,
	centerVertical = false,
	hideCloseLabel = false,
	content = null,
	disableBodyScroll = false,
} = {}) => {

	const onCloseDefault = () => {
		$('body').removeClass('mfp-modal-open');
		onClose();
	}

	if (disableBodyScroll) {
		$('body').addClass('mfp-modal-open');
	}

	let $target = null;

	if (!content) {
		const {modalTarget} = $link.data();
		$target = $(modalTarget);

		if (!$target.length) {
			return;
		}
	}


	let mainClass = 'v4-typography modal-layer';
	if (compact) {
		mainClass += ' compact';
	}
	if (centerVertical) {
		mainClass += ' center-vertical'
	}
	let closeMarkup = '<button type="button" class="mfp-close"><i class="is-icon is-icon-arrow is-icon-arrow-left"></i>';
	if (!hideCloseLabel) {
		closeMarkup += ' %title%';
	}
	closeMarkup += '</button>';
	history.pushState(null, '', '');
	const src = content || $target;
	$.magnificPopup.open({
		items: {src},
		type: 'inline',
		mainClass,
		closeMarkup,
		tClose: 'Takaisin',
		gallery: {
			enabled: true,
			arrowMarkup: '<button type="button" type="button" class="mfp-arrow mfp-arrow-%dir%"><i class="is-icon is-icon-arrow mfp-prevent-close"></i> <span class="mfp-arrow-title mfp-prevent-close">%title%</span></button>',
			tPrev: '',
			tNext: '',
			tCounter: ''
		},
		callbacks: {
			close: onCloseDefault
		}
	});
}

export const closeModal = (e) => {
	if ($.magnificPopup.instance.isOpen) {
		$.magnificPopup.close();
	}
}

export default (selector = '.modal-link') => {
	window.onpopstate = closeModal;

	$('body').on('click', selector, (e) => {
		e.preventDefault();
		openModal($(e.target));
	});

}
